import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";

export const copyEntities = async (params: {
  entities: ZUid[];
  attributes?: ZUid[];
  parentEntityId: ZUid;
}) => {
  await rest.post(apiObjUrl("/entities/list-copy"), params);
};

export const copyEntitiesWithParents = async (params: {
  entities: ZUid[];
  attributes?: ZUid[];
  parentEntities: ZUid[];
}) => {
  await rest.post(apiObjUrl("/entities/list-copy-with-parents"), params);
};
